export default __webpack_public_path__ + "static/media/score_table.555257ca.jpg";